import healthPlansStrings from 'modules/healthPlans/strings';

const { categories } = healthPlansStrings;
export const healthPlanCategories = [
  {
    name: categories.doctorConsultations,
    icon: '"\\e91a"',
    path: 'doctor-consultations-price-lists',
  },
  {
    name: categories.pharmacies,
    icon: '"\\e918"',
    path: 'pharmacies-price-lists',
  },
  {
    name: categories.labs,
    icon: '"\\e916"',
    path: 'labs-price-lists',
  },
  {
    name: categories.scans,
    icon: '"\\e917"',
    path: 'scans-price-lists',
  },
  {
    name: categories.clinicServices,
    icon: '"\\e919"',
    path: 'clinical-services-price-lists',
  },
  {
    name: categories.surgical,
    icon: '"\\e91b"',
    path: 'surgical-price-lists',
  },
  {
    name: categories.providerDiscounts,
    icon: '"\\e91b"',
    path: 'provider-discounts',
  },
];
